import axios from "axios";
import { dashboardUrl } from "../apirest";

export async function getUserNru({ courseid, username }) {
  try {
    const url = `${dashboardUrl}/cnf/endpoint-rnu-get.php?client_id=4&course_id=${courseid}&username=${username}`;
    const response = await axios.get(url);

    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
}
